export const I18nNamespace = {
  CustomerPortal: "customer-portal",
  CustomerPortalShared: "customer-portal-shared",
  I18n: "i18n",
  MerchantApp: "merchant-app",
  MerchantFulfillmentApp: "merchant-fulfillment-app",
  Model: "model",
  ReturnApp: "return-app",
  Web: "web",
} as const;

export type I18nNamespaceType =
  (typeof I18nNamespace)[keyof typeof I18nNamespace];

export const ALL_NAMESPACES = Object.values(I18nNamespace);
